import React from "react";
import { Chip } from "@material-ui/core";
import { Domain } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

type Props = {
  children: string;
};

export function CustomerGroupChip(props: Props) {
  const classes = useStyles({});

  return (
    <Chip
      label={props.children}
      variant="outlined"
      classes={classes}
      icon={<Domain style={{ fontSize: 12 }} />}
    />
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    height: 18
  },

  label: {
    fontSize: theme.typography.pxToRem(10)
  }
}));
